import axios from '../javascript/custom-axios'
const V1 = '/v1'
const RESOURCE_NAME = '/gifts'

export default {
    getUserStatus() {
        return axios.get(`${V1}${RESOURCE_NAME}/getUserStatus`)
    },

    spinWheel() {
        return axios.put(`${V1}${RESOURCE_NAME}/spinWheel`)
    },

    winGift() {
        return axios.put(`${V1}${RESOURCE_NAME}/winGift`)
    },
}